import firebase from 'firebase/app'
import 'firebase/auth'

/**
 * Checks if the session has expired based on custom claims:
 * - sessionIdleMaxAgeSec
 * - sessionLastActivitySec (fallback to authTime)
 * @returns {Promise<boolean>} true if session is expired, false otherwise
 */
export const isSessionExpired = async (): Promise<boolean> => {
  const user = firebase.auth().currentUser
  if (!user) return true

  // Get fresh token to ensure claims are up-to-date
  const idTokenResult = await user.getIdTokenResult(true)

  const claims: any = idTokenResult.claims || {}
  const maxAge: number = typeof claims.sessionIdleMaxAgeSec === 'number' ? claims.sessionIdleMaxAgeSec : 0
  const now = Date.now() / 1000

  // No timeout enforced
  if (maxAge === 0) return false

  let lastActivitySec: number

  // Prefer custom last activity timestamp from claims
  if (typeof claims.sessionLastActivitySec === 'number' && claims.sessionLastActivitySec > 0) {
    lastActivitySec = claims.sessionLastActivitySec
  } else if (idTokenResult.authTime) {
    // Fallback to authTime if custom claim is missing or invalid
    lastActivitySec = new Date(idTokenResult.authTime).getTime() / 1000;
  } else {
    // Very defensive fallback: treat as "just now" to avoid blocking login
    lastActivitySec = now
  }

  const buffer = 3; // seconds, to account for clock skew or network delay
  return now - lastActivitySec >= (maxAge - buffer);
}
